import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IPointsOfferReviewRatingHistory } from '@/shared/model/points-offer-review-rating-history.model';

const baseApiUrl = 'api/points-offer-review-rating-histories';
const baseSearchApiUrl = 'api/_search/points-offer-review-rating-histories?query=';

export default class PointsOfferReviewRatingHistoryService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IPointsOfferReviewRatingHistory> {
    return new Promise<IPointsOfferReviewRatingHistory>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IPointsOfferReviewRatingHistory): Promise<IPointsOfferReviewRatingHistory> {
    return new Promise<IPointsOfferReviewRatingHistory>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IPointsOfferReviewRatingHistory): Promise<IPointsOfferReviewRatingHistory> {
    return new Promise<IPointsOfferReviewRatingHistory>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
